import * as React from "react";
import { Link } from "react-router-dom";
import { Card, Badge, List } from "antd";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { projectGroupList } from "Pages/Admin/Stores/ProjectGroupStore";

interface AdminCardProps extends AdminDashboardSection, WithTranslation {}

export const PGAdminCard = withTranslation(I18N_NS.ADMIN)(
  class extends React.Component<AdminCardProps> {
    renderLinks = (group: API_ProjectGroup) => {
      const { t } = this.props;
      const linksMap = {
        users: {
          route: {
            pathname: `/admin/pg/${group.id}/user`,
            state: { id: group.id, name: group.name },
          },
          name: "Users",
        },
        projects: {
          route: {
            pathname: `/admin/pg/${group.id}/projects`,
            state: { id: group.id, name: group.name },
          },
          name: "Projects",
        },
        templates: {
          route: {
            pathname: `/admin/pg/${group.id}/templates`,
            state: { id: group.id, name: group.name },
          },
          name: "Template-Projects",
        },
      };
      const link = (type: "users" | "projects" | "templates") => {
        return (
          <Link to={linksMap[type].route} className="link" style={{ marginRight: 25 }}>
            {t(linksMap[type].name)}
          </Link>
        );
      };

      return (
        <>
          {group.createUser ? link("users") : null}
          {link("projects")}
          {group.createProject ? link("templates") : null}
        </>
      );
    };

    render() {
      return (
        <List
          bordered={false}
          dataSource={projectGroupList.data.slice()}
          renderItem={(group: API_ProjectGroup) => {
            return (
              <List.Item className="flex">
                <List.Item.Meta title={group.name} description={this.renderLinks(group)} />
              </List.Item>
            );
          }}
        />
      );
    }
  }
);

export const AdminCard = withTranslation(I18N_NS.ADMIN)(
  class extends React.Component<AdminCardProps> {
    renderStatus = (status: boolean) => {
      const { t } = this.props;
      return status ? <Badge status="success" text={t("Active")} /> : <Badge status="error" text={t("Inactive")} />;
    };

    render() {
      const { roles, tools, title, t } = this.props;
      const isPrGpAdmin = roles.includes("PRGROUPADMIN");

      return (
        <Card title={t(title)} className="mb-2">
          {isPrGpAdmin ? (
            <PGAdminCard {...this.props} />
          ) : (
            <List
              bordered={false}
              dataSource={tools}
              renderItem={(item: AdminTools) => {
                return (
                  <List.Item className="flex" style={{ justifyContent: "space-between" }}>
                    {item.link ? (
                      <Link to={item.link} className="link">
                        {t(item.label)}
                      </Link>
                    ) : (
                      t(item.label)
                    )}
                    {Object.prototype.hasOwnProperty.call(item, "status") && this.renderStatus(item.status)}
                  </List.Item>
                );
              }}
            />
          )}
        </Card>
      );
    }
  }
);
